import { render } from "./App.vue?vue&type=template&id=144ffb2a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=144ffb2a&lang=scss"

import exportComponent from "/home/eigyo65user/mystep/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__